// Generated by purs version 0.14.5
"use strict";
var Box = require("../Box/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var React_Basic_DOM = require("../React.Basic.DOM/index.js");
var TacoConstants = require("../TacoConstants/index.js");
var TacoTable = require("../TacoTable/index.js");
var TacoTable_Styles = require("../TacoTable.Styles/index.js");
var TacoTable_Types = require("../TacoTable.Types/index.js");
var TofuHooks = require("../TofuHooks/index.js");
var ColName = (function () {
    function ColName() {

    };
    ColName.value = new ColName();
    return ColName;
})();
var ColQuantity = (function () {
    function ColQuantity() {

    };
    ColQuantity.value = new ColQuantity();
    return ColQuantity;
})();
var ColPrice = (function () {
    function ColPrice() {

    };
    ColPrice.value = new ColPrice();
    return ColPrice;
})();
var styleSet = TacoTable_Styles.foldingTableStyleSet;
var exampleTable = TacoTable.mkTableStateless(TofuHooks.getNameVoid)("ExampleTable");
var exampleData = [ {
    key: "apple",
    name: "Apple",
    quantity: 42.0,
    price: 1.23
}, {
    key: "banana",
    name: "Banana",
    quantity: 7.0,
    price: 2.34
}, {
    key: "coconut",
    name: "Coconut",
    quantity: 3.0,
    price: 3.45
} ];
var example1 = "\x0aimport TacoTable as TacoTable\x0aimport TacoTable.Types as TacoTableTypes\x0a\x0aexampleTable :: forall rowData. HookComponent (TacoTable.PropsStateless Void rowData)\x0aexampleTable = TacoTable.mkTableStateless \"ExampleTable\"\x0a\x0atype ExampleData =\x0a  { key :: String\x0a  , name :: String\x0a  , price :: Number\x0a  , quantity :: Number\x0a  }\x0a\x0aexampleData :: Array ExampleData\x0aexampleData =\x0a  [ { key: \"apple\", name: \"Apple\", quantity: 42.0, price: 1.23 }\x0a  , { key: \"banana\", name: \"Banana\", quantity: 7.0, price: 2.34 }\x0a  , { key: \"coconut\", name: \"Coconut\", quantity: 3.0, price: 3.45 }\x0a  ]\x0a\x0amkRow ::\x0a  { className :: String\x0a  , rowData :: ExampleData\x0a  , rowKey :: String\x0a  }\x0a  -> TacoTableTypes.TacoRow Void ExampleData\x0amkRow { className, rowData, rowKey } = TacoTableTypes.TacoRow\x0a  { className\x0a  , rowData\x0a  , foldingElement: Nothing\x0a  , onClick: \\_ -> pure unit\x0a  , rowKey\x0a  , columns\x0a  }\x0a\x0adata Column\x0a  = ColName\x0a  | ColQuantity\x0a  | ColPrice\x0a\x0agetRow :: ExampleData -> TacoTableTypes.TacoRow Void ExampleData\x0agetRow r = mkRow\x0a  { className: \"ExampleTableRow\"\x0a  , rowData: r\x0a  , rowKey: r.key\x0a  }\x0a\x0acolumns :: Array (TacoTableTypes.Column Void ExampleData)\x0acolumns =\x0a  [ TacoTableTypes.Column { key: \"name\", label: R.text \"Nimi\", width: TacoTableTypes.Flex 3, sortProperty: TacoTableTypes.noSortProperty, cell: TacoTableTypes.PlainTextCell _.name, headerJSX: Nothing }\x0a  , TacoTableTypes.Column { key: \"quantity\", label: R.text \"M\xe4\xe4r\xe4\", width: TacoTableTypes.FlexMinWidth 1 \"150px\", sortProperty: TacoTableTypes.noSortProperty, cell: TacoTableTypes.PlainNumberCell (DecimalPrecision 0) _.quantity, headerJSX: Nothing }\x0a  , TacoTableTypes.Column { key: \"price\", label: R.text \"Hinta\", width: TacoTableTypes.Flex 1, sortProperty: TacoTableTypes.noSortProperty, cell: TacoTableTypes.PlainEuroCell _.price, headerJSX: Nothing }\x0a  ]\x0a\x0astyleSet :: TableStyleSet ExampleData\x0astyleSet = foldingTableStyleSet\x0a\x0a[ box \"tacoTableExampleWrapper\"\x0a    [ Width $ CustomSize \"500px\" ]\x0a    [ TacoTable.tableStateless exampleTable\x0a        { sortProperty: Nothing\x0a        , onSort: pure mempty\x0a        , sortingOrder: TacoTableTypes.Ascending\x0a        , rows: getRow <$> exampleData\x0a        , showHeader: true\x0a        , styleSet\x0a        }\x0a    ]\x0a]\x0a";
var columns = [ {
    key: "name",
    label: React_Basic_DOM.text("Nimi"),
    width: new TacoTable_Types.Flex(3),
    sortProperty: TacoTable_Types.noSortProperty,
    cell: new TacoTable_Types.PlainTextCell(function (v) {
        return v.name;
    }),
    headerJSX: Data_Maybe.Nothing.value
}, {
    key: "quantity",
    label: React_Basic_DOM.text("M\xe4\xe4r\xe4"),
    width: new TacoTable_Types.FlexMinWidth(1, "150px"),
    sortProperty: TacoTable_Types.noSortProperty,
    cell: new TacoTable_Types.PlainNumberCell(0, function (v) {
        return v.quantity;
    }),
    headerJSX: Data_Maybe.Nothing.value
}, {
    key: "price",
    label: React_Basic_DOM.text("Hinta"),
    width: new TacoTable_Types.Flex(1),
    sortProperty: TacoTable_Types.noSortProperty,
    cell: new TacoTable_Types.PlainEuroCell(function (v) {
        return v.price;
    }),
    headerJSX: Data_Maybe.Nothing.value
} ];
var mkRow = function (v) {
    return {
        className: v.className,
        rowData: v.rowData,
        foldingElement: Data_Maybe.Nothing.value,
        onClick: function (v1) {
            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
        },
        rowKey: v.rowKey,
        columns: columns
    };
};
var getRow = function (r) {
    return mkRow({
        className: "ExampleTableRow",
        rowData: r,
        rowKey: r.key
    });
};
var sections = [ {
    title: "Default",
    view: [ Box.box("tacoTableExampleWrapper")([ Box.Width.create(new TacoConstants.CustomSize("500px")) ])([ TacoTable.tableStateless(TofuHooks.getNameVoid)(Data_Eq.eqVoid)(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "quantity";
        }
    })(Data_Eq.eqNumber))()({
        reflectSymbol: function () {
            return "price";
        }
    })(Data_Eq.eqNumber))()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "key";
        }
    })(Data_Eq.eqString)))(exampleTable)({
        sortProperty: Data_Maybe.Nothing.value,
        onSort: Control_Applicative.pure(Control_Applicative.applicativeFn)(Data_Monoid.mempty(Effect.monoidEffect(Data_Monoid.monoidUnit))),
        sortingOrder: TacoTable_Types.Ascending.value,
        rows: Data_Functor.map(Data_Functor.functorArray)(getRow)(exampleData),
        columns: columns,
        showHeader: true,
        styleSet: styleSet,
        onResize: function (v) {
            return function (v1) {
                return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
            };
        },
        columnSizeOffsets: Data_Maybe.Nothing.value
    }) ]) ],
    code: example1
} ];
var demoView = {
    sections: sections,
    title: "TacoTable",
    description: "Component providing multiple filter inputs"
};
module.exports = {
    demoView: demoView
};
